
const PageCultivationLists = () => import('@/modules/cultivation/PageCultivationLists')

export default [
    {
        path: '/cultivationLists',
        name: 'cultivationLists',
        component: PageCultivationLists,
        meta: {
            title: '名单路库',
            needLogin: true,
            isBlack: true
        },
    },

]
